// extracted by mini-css-extract-plugin
module.exports = {"nav__links":"NavLinks_nav__links__VTeju","nav__submenu-links":"NavLinks_nav__submenu-links__NvzuW"};